/**
 * Comprehensive list of music genres for dropdown selection
 */
const genresData = [
  // Popular genres
  'Rock',
  'Pop',
  'Hip Hop',
  'Rap',
  'R&B',
  'Soul',
  'Jazz',
  'Blues',
  'Country',
  'Folk',
  'Electronic',
  'Dance',
  'EDM',
  'House',
  'Techno',
  'Dubstep',
  'Trap',
  'Classical',
  'Metal',
  'Punk',
  'Reggae',
  'Ska',
  'Funk',
  'Disco',
  'Gospel',
  'Christian',
  'Latin',
  'World',
  
  // Rock subgenres
  'Alternative Rock',
  'Indie Rock',
  'Hard Rock',
  'Soft Rock',
  'Progressive Rock',
  'Psychedelic Rock',
  'Classic Rock',
  'Grunge',
  'Garage Rock',
  'Punk Rock',
  
  // Metal subgenres
  'Heavy Metal',
  'Death Metal',
  'Black Metal',
  'Thrash Metal',
  'Doom Metal',
  'Power Metal',
  'Progressive Metal',
  'Nu Metal',
  'Metalcore',
  
  // Electronic/Dance subgenres
  'Ambient',
  'Trance',
  'Drum and Bass',
  'Breakbeat',
  'Chillout',
  'Lofi',
  'Industrial',
  'Synthwave',
  'Vaporwave',
  
  // Jazz subgenres
  'Bebop',
  'Swing',
  'Smooth Jazz',
  'Fusion',
  'Free Jazz',
  'Big Band',
  
  // Hip Hop/Rap subgenres
  'Gangsta Rap',
  'Conscious Hip Hop',
  'Trap Music',
  'Drill',
  'Old School Hip Hop',
  'Underground Hip Hop',
  
  // Other genres
  'Experimental',
  'Avant-garde',
  'New Age',
  'Soundtrack',
  'Musical Theatre',
  'Opera',
  'A Cappella',
  'Bluegrass',
  'Americana',
  'Motown',
  'Bossa Nova',
  'Afrobeat',
  'K-Pop',
  'J-Pop',
];

export default genresData;
